import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface DocInsightsState {
  isOpen: boolean;
  docId: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class DocInsightsService {
  private stateSubject = new BehaviorSubject<DocInsightsState>({
    isOpen: false,
    docId: null,
  });

  state$: Observable<DocInsightsState> = this.stateSubject.asObservable();

  get currentState(): DocInsightsState {
    return this.stateSubject.value;
  }

  open(docId: string | null): void {
    this.stateSubject.next({
      isOpen: true,
      docId,
    });
  }

  close(): void {
    this.stateSubject.next({
      ...this.stateSubject.value,
      isOpen: false,
    });
  }

  setDocId(docId: string | null): void {
    this.stateSubject.next({
      ...this.stateSubject.value,
      docId,
    });
  }
}
